// extracted by mini-css-extract-plugin
export default {"Maindiv":"EditNameAvtar_Maindiv__PF7KO","container":"EditNameAvtar_container__dyKjT","stickyWrapper":"EditNameAvtar_stickyWrapper__COLij"};